import { sbaAxios } from "../utils/sbaAxios";
import {getSecurityTypeDdl,getInvestmentStatusDdl,getAssetclass,getFundStatusDdl,getPrimaryAnalystDdl,
    getSecondaryAnalystDdl, getStrategyDdl, getSubStrategyDdl, getRegionDdl, getSubRegionDdl, getSectorDdl, getSubSectorDdl, getAssetAUMList, getAssetReturnsList,getAssetShareclassTermsList, getAssetPrivateExposureSummary} from "../../config/apiConfig";
import {
    FETCH_ASSETSECURITY_BEGIN,
    FETCH_ASSETSECURITY_SUCCESS,
    FETCH_ASSETSECURITY_FAILURE,

    FETCH_ASSETINVESTMENT_BEGIN,
    FETCH_ASSETINVESTMENT_SUCCESS,
    FETCH_ASSETINVESTMENT_FAILURE,

    FETCH_ASSETCLASS_BEGIN,
    FETCH_ASSETCLASS_SUCCESS,
    FETCH_ASSETCLASS_FAILURE,

    FETCH_FUNDSTATUS_BEGIN,
    FETCH_FUNDSTATUS_SUCCESS,
    FETCH_FUNDSTATUS_FAILURE,

    FETCH_PRIMARYANALYST_BEGIN,
    FETCH_PRIMARYANALYST_SUCCESS,
    FETCH_PRIMARYANALYST_FAILURE,

    FETCH_SECONDARYANALYST_BEGIN,
    FETCH_SECONDARYANALYST_SUCCESS,
    FETCH_SECONDARYANALYST_FAILURE,

    FETCH_STRATEGY_BEGIN,
    FETCH_STRATEGY_SUCCESS,
    FETCH_STRATEGY_FAILURE,

    FETCH_SUBSTRATEGY_BEGIN,
    FETCH_SUBSTRATEGY_SUCCESS,
    FETCH_SUBSTRATEGY_FAILURE,

    FETCH_REGION_BEGIN,
    FETCH_REGION_SUCCESS,
    FETCH_REGION_FAILURE,

    FETCH_SUBREGION_BEGIN,
    FETCH_SUBREGION_SUCCESS,
    FETCH_SUBREGION_FAILURE,

    FETCH_SECTOR_BEGIN,
    FETCH_SECTOR_SUCCESS,
    FETCH_SECTOR_FAILURE,

    FETCH_SUBSECTOR_BEGIN,
    FETCH_SUBSECTOR_SUCCESS,
    FETCH_SUBSECTOR_FAILURE,

    FETCH_ASSETAUMDETAILS_BEGIN,
    FETCH_ASSETAUMDETAILS_SUCCESS,
    FETCH_ASSETAUMDETAILS_FAILURE,

    FETCH_ASSETRETURNS_BEGIN,
    FETCH_ASSETRETURNS_SUCCESS,
    FETCH_ASSETRETURNS_FAILURE,

    FETCH_ASSETSHARECLASSTERMS_BEGIN,
    FETCH_ASSETSHARECLASSTERMS_SUCCESS,
    FETCH_ASSETSHARECLASSTERMS_FAILURE,
    FETCH_ASSETPRIVATEEXPOSURE_BEGIN,
    FETCH_ASSETPRIVATEEXPOSURE_SUCCESS,
    FETCH_ASSETPRIVATEEXPOSURE_FAILURE,

  } from '../constants/assetdetails';


//security Type..

export const getSecurityType=()=> {
 
    return (dispatch) => {
        dispatch(fetchSecurityTypeBegin());
        sbaAxios({
            url: `${getSecurityTypeDdl}`,
            method: 'get',
        })
       .then((repos) => {
         const securityType = [ {
          "AssetTypeId": null,
          "AssetTypeName": "--Please Select--"
        },...repos.sort((a, b) =>
        a.AssetTypeName.localeCompare(b.AssetTypeName))];
         //Add logic to format the DataItem if needed using map 

         dispatch(fetchSecurityTypeSuccess(securityType));
         return securityType;
       })
       .catch((error) => dispatch(fetchSecurityTypeFailure(error)));
   };
 }
 
 export const fetchSecurityTypeBegin = () => ({
   type: FETCH_ASSETSECURITY_BEGIN,
 });

 export const fetchSecurityTypeSuccess = (securityType) => ({

   type: FETCH_ASSETSECURITY_SUCCESS,
   payload: {securityType},
 });
 
 
 export const fetchSecurityTypeFailure = (errorMessage) => ({
   type: FETCH_ASSETSECURITY_FAILURE,
   payload: {errorMessage}
 });
 
//GET  INVEST STATUS
 export const getInvestmentStatus=()=> {

  return (dispatch) => {
   dispatch(fetchInvestmentstatusBegin());
      sbaAxios({
          url: `${getInvestmentStatusDdl}`,
          method: 'get',
      })
        .then((repos) => {
       const Investmentstatus = [{
        "EnumValue": null,
        "EnumName": "--Please Select--",
        },...repos.sort((a, b) =>
        a.EnumName.localeCompare(b.EnumName))];
       //Add logic to format the DataItem if needed using map
       dispatch(fetchInvestmentstatusSuccess(Investmentstatus));
       return Investmentstatus;
     })
     .catch((error) => dispatch(fetchInvestmentstatusFailure(error)));
 };
}
export const fetchInvestmentstatusBegin = () => ({
  type: FETCH_ASSETINVESTMENT_BEGIN,
});

export const fetchInvestmentstatusSuccess = (Investmentstatus) => ({

  type: FETCH_ASSETINVESTMENT_SUCCESS,
  payload: {Investmentstatus},
});


export const fetchInvestmentstatusFailure = (errorMessage) => ({
  type: FETCH_ASSETINVESTMENT_FAILURE,
  payload: {errorMessage}
});

// GET ASSET CLASS 

export const getAssetClass=()=> {
 
   return (dispatch) => {
       dispatch(fetchAssetClassBegin());
       sbaAxios({
           url: `${getAssetclass}`,
           method: 'get',
       })
      .then((repos) => {
        const assetClass = [{
          "ClassificationId": null,
          "ClassificationValue": "--Please Select--",
          },...repos.sort((a, b) =>
          a.ClassificationValue.localeCompare(b.ClassificationValue))];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchAssetClassSuccess(assetClass));
        return assetClass;
      })
      .catch((error) => dispatch(fetchAssetClassFailure(error)));
  };
 }
 export const fetchAssetClassBegin = () => ({
   type: FETCH_ASSETCLASS_BEGIN,
 });
 
 export const fetchAssetClassSuccess = (assetClass) => ({
 
   type: FETCH_ASSETCLASS_SUCCESS,
   payload: {assetClass},
 });
 
 
 export const fetchAssetClassFailure = (errorMessage) => ({
   type: FETCH_ASSETCLASS_FAILURE,
   payload: {errorMessage}
 });
 

 // GET fUND STATUS

 export const getFundStatus=()=> {

   return (dispatch) => {
       dispatch(fetchFundStatusBegin());
       sbaAxios({
           url: `${getFundStatusDdl}`,
           method: 'get',
       })
      .then((repos) => {
        const fundStatus = [{
          "AssetStatusId": null,
          "AssetStatus": "--Please Select--"
        },...repos];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchFundStatusSuccess(fundStatus));
        return fundStatus;
      })
      .catch((error) => dispatch(fetchFundStatusFailure(error)));
  };
 }
 export const fetchFundStatusBegin = () => ({
   type: FETCH_FUNDSTATUS_BEGIN,
 });
 
 export const fetchFundStatusSuccess = (fundStatus) => ({
 
   type: FETCH_FUNDSTATUS_SUCCESS,
   payload: {fundStatus},
 });
 
 
 export const fetchFundStatusFailure = (errorMessage) => ({
   type: FETCH_FUNDSTATUS_FAILURE,
   payload: {errorMessage}
 });
 

 // GET Primary Analyst

 export const getPrimaryAnalyst=()=> {
   return (dispatch) => {
       dispatch(fetchPrimaryAnalystBegin());
       sbaAxios({
           url: `${getPrimaryAnalystDdl}`,
           method: 'get',
       })
      .then((repos) => {
        const primaryAnalyst = [{
          "UserId": null,
          "AnalystName": "--Please Select--"
        },...repos.sort((a, b) =>
        a.AnalystName.localeCompare(b.AnalystName))];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchPrimaryAnalystSuccess(primaryAnalyst));
        return primaryAnalyst;
      })
      .catch((error) => dispatch(fetchPrimaryAnalystFailure(error)));
  };
 }
 export const fetchPrimaryAnalystBegin = () => ({
   type: FETCH_PRIMARYANALYST_BEGIN,
 });
 
 export const fetchPrimaryAnalystSuccess = (primaryAnalyst) => ({
 
   type: FETCH_PRIMARYANALYST_SUCCESS,
   payload: {primaryAnalyst},
 });
 
 
 export const fetchPrimaryAnalystFailure = (errorMessage) => ({
   type: FETCH_PRIMARYANALYST_FAILURE,
   payload: {errorMessage}
 });
 
// GET Strategy 

export const getStrategy=()=> {
    return (dispatch) => {
        dispatch(fetchStrategyBegin());
        sbaAxios({
            url: `${getStrategyDdl}`,
            method: 'get',
        })
      .then((repos) => {
        const strategy = [{
          "ClassificationId": null,
          "ClassificationValue": "--Please Select--",
          },...repos];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchStrategySuccess(strategy));
        return strategy;
      })
      .catch((error) => dispatch(fetchStrategyFailure(error)));
  };
 }
 export const fetchStrategyBegin = () => ({
   type: FETCH_STRATEGY_BEGIN,
 });
 
 export const fetchStrategySuccess = (strategy) => ({
 
   type: FETCH_STRATEGY_SUCCESS,
   payload: {strategy},
 });
 
 
 export const fetchStrategyFailure = (errorMessage) => ({
   type: FETCH_STRATEGY_FAILURE,
   payload: {errorMessage}
 });
 



// GET Secondary Analyst

export const getSecondaryAnalyst=()=> {
   return (dispatch) => {
       dispatch(fetchSecondaryAnalystBegin());
       sbaAxios({
           url: `${getSecondaryAnalystDdl}`,
           method: 'get',
       })
      .then((repos) => {
        const secondaryAnalyst = [{
          "UserId": null,
          "AnalystName": "--Please Select--"
        },...repos.sort((a, b) =>
        a.AnalystName.localeCompare(b.AnalystName))];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchSecondaryAnalystSuccess(secondaryAnalyst));
        return secondaryAnalyst;
      })
      .catch((error) => dispatch(fetchSecondaryAnalystFailure(error)));
  };
 }
 export const fetchSecondaryAnalystBegin = () => ({
   type: FETCH_SECONDARYANALYST_BEGIN,
 });
 
 export const fetchSecondaryAnalystSuccess = (secondaryAnalyst) => ({
 
   type: FETCH_SECONDARYANALYST_SUCCESS,
   payload: {secondaryAnalyst},
 });
 
 
 export const fetchSecondaryAnalystFailure = (errorMessage) => ({
   type: FETCH_SECONDARYANALYST_FAILURE,
   payload: {errorMessage}
 });
 


 // GET Sub Strategy

export const getSubStrategy=()=> {
   return (dispatch) => {
       dispatch(fetchSubStrategyBegin());
       sbaAxios({
           url: `${getSubStrategyDdl}`,
           method: 'get',
       })
      .then((repos) => {
        const subStrategy = [{
          "ClassificationId": null,
          "ClassificationValue": "--Please Select--",
          "ParentClassification": 0
          },...repos];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchSubStrategySuccess(subStrategy));
        return subStrategy;
      })
      .catch((error) => dispatch(fetchSubStrategyFailure(error)));
  };
 }
 export const fetchSubStrategyBegin = () => ({
   type: FETCH_SUBSTRATEGY_BEGIN,
 });
 
 export const fetchSubStrategySuccess = (subStrategy) => ({
 
   type: FETCH_SUBSTRATEGY_SUCCESS,
   payload: {subStrategy},
 });
 
 
 export const fetchSubStrategyFailure = (errorMessage) => ({
   type: FETCH_SUBSTRATEGY_FAILURE,
   payload: {errorMessage}
 });
 
// GET Region

export const getRegion=()=> {
   return (dispatch) => {
       dispatch(fetchRegionBegin());
       sbaAxios({
           url: `${getRegionDdl}`,
           method: 'get',
       })
      .then((repos) => {
        const region = [{
          "ClassificationId": null,
          "ClassificationValue": "--Please Select--",
          "ParentClassification": 0
          },...repos];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchRegionSuccess(region));
        return region;
      })
      .catch((error) => dispatch(fetchRegionFailure(error)));
  };
 }
 export const fetchRegionBegin = () => ({
   type: FETCH_REGION_BEGIN,
 });
 
 export const fetchRegionSuccess = (region) => ({
 
   type: FETCH_REGION_SUCCESS,
   payload: {region},
 });
 
 
 export const fetchRegionFailure = (errorMessage) => ({
   type: FETCH_REGION_FAILURE,
   payload: {errorMessage}
 });
 
 //GET subRegion

 export const getSubRegion=()=> {
    return (dispatch) => {
        dispatch(fetchSubRegionBegin());
        sbaAxios({
            url: `${getSubRegionDdl}`,
            method: 'get',
        })
       .then((repos) => {
         const subregion = [{
          "ClassificationId": null,
          "ClassificationValue": "--Please Select--",
          "ParentClassification": 0
          },...repos];
         //Add logic to format the DataItem if needed using map
         dispatch(fetchSubRegionSuccess(subregion));
         return subregion;
       })
       .catch((error) => dispatch(fetchSubRegionFailure(error)));
   };
  }
  export const fetchSubRegionBegin = () => ({
    type: FETCH_SUBREGION_BEGIN,
  });
  
  export const fetchSubRegionSuccess = (subregion) => ({
  
    type: FETCH_SUBREGION_SUCCESS,
    payload: {subregion},
  });
  
  
  export const fetchSubRegionFailure = (errorMessage) => ({
    type: FETCH_SUBREGION_FAILURE,
    payload: {errorMessage}
  });
  
 
  //GET sector 

 export const getSector=()=> {
   return (dispatch) => {
       dispatch(fetchSectorBegin());
       sbaAxios({
           url: `${getSectorDdl}`,
           method: 'get',
       })
      .then((repos) => {
        const sector = [{
          "ClassificationId": null,
          "ClassificationValue": "--Please Select--",
          "ParentClassification": 0
          },...repos];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchSectorSuccess(sector));
        return sector;
      })
      .catch((error) => dispatch(fetchSectorFailure(error)));
  };
 }
 export const fetchSectorBegin = () => ({
   type: FETCH_SECTOR_BEGIN,
 });
 
 export const fetchSectorSuccess = (sector) => ({
 
   type: FETCH_SECTOR_SUCCESS,
   payload: {sector},
 });
 
 
 export const fetchSectorFailure = (errorMessage) => ({
   type: FETCH_SECTOR_FAILURE,
   payload: {errorMessage}
 });
 
//GET Subsector

export const getSubSector=()=> {
   return (dispatch) => {
       dispatch(fetchSubSectorBegin());
       sbaAxios({
           url: `${getSubSectorDdl}`,
           method: 'get',
       })
      .then((repos) => {
        const subsector = [{
          "ClassificationId": null,
          "ClassificationValue": "--Please Select--",
          "ParentClassification": 0
          },...repos];
        //Add logic to format the DataItem if needed using map
        dispatch(fetchSubSectorSuccess(subsector));
        return subsector;
      })
      .catch((error) => dispatch(fetchSubSectorFailure(error)));
  };
 }
 export const fetchSubSectorBegin = () => ({
   type: FETCH_SUBSECTOR_BEGIN,
 });
 
 export const fetchSubSectorSuccess = (subsector) => ({
 
   type: FETCH_SUBSECTOR_SUCCESS,
   payload: {subsector},
 });
 
 
 export const fetchSubSectorFailure = (errorMessage) => ({
   type: FETCH_SUBSECTOR_FAILURE,
   payload: {errorMessage}
 });
 
//GET AssetAUM

export const getAssetAUM = (AssetId,Date) => {
    return (dispatch) => {
        dispatch(fetchAssetAUMWBegin());
        sbaAxios({
            url: `${getAssetAUMList}${AssetId},${Date}`,
            method: 'get',
        })
            .then((repos) => {
                const AUMData = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(fetchAssetAUMWSuccess(AUMData));
                return AUMData;
            })
            .catch((error) => dispatch(fetchAssetAUMWFailure(error)));
    };
}
export const fetchAssetAUMWBegin = () => ({
    type: FETCH_ASSETAUMDETAILS_BEGIN,
});

export const fetchAssetAUMWSuccess = (assetAUM) => ({

    type: FETCH_ASSETAUMDETAILS_SUCCESS,
    payload: { assetAUM },
});


export const fetchAssetAUMWFailure = (errorMessage) => ({
    type: FETCH_ASSETAUMDETAILS_FAILURE,
    payload: { errorMessage }
});

//GET AssetReturns

export const getAssetReturns = (AssetId, entitytype) => {
    return (dispatch) => {
        dispatch(fetchAssetReturnBegin());
        sbaAxios({
            url: `${getAssetReturnsList}${AssetId},${entitytype}`,
            method: 'get',
        })
            .then((repos) => {
                const assetReturnData = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(fetchAssetReturnSuccess(assetReturnData));
                return assetReturnData;
            })
            .catch((error) => dispatch(fetchAssetReturnFailure(error)));
    };
}
export const fetchAssetReturnBegin = () => ({
    type: FETCH_ASSETRETURNS_BEGIN,
});

export const fetchAssetReturnSuccess = (assetReturns) => ({

    type: FETCH_ASSETRETURNS_SUCCESS,
    payload: { assetReturns },
});


export const fetchAssetReturnFailure = (errorMessage) => ({
    type: FETCH_ASSETRETURNS_FAILURE,
    payload: { errorMessage }
});

//GET AssetShareClass Terms
export const getAssetShareclassTerms = (AssetId) => {
  return (dispatch) => {
      dispatch(fetchAssetReturnBegin());
      sbaAxios({
          url: `${getAssetShareclassTermsList}${AssetId}`,
          method: 'get',
      })
          .then((repos) => {
              const assetshareclassterms = repos;
              //Add logic to format the DataItem if needed using map
              dispatch(fetchShareclassTermsSuccess(assetshareclassterms));
              return assetshareclassterms;
          })
          .catch((error) => dispatch(fetchShareclassTermsFailure(error)));
  };
}
export const fetchShareclassTermsBegin = () => ({
  type: FETCH_ASSETSHARECLASSTERMS_BEGIN,
});

export const fetchShareclassTermsSuccess = (assetShareClassTerms) => ({

  type: FETCH_ASSETSHARECLASSTERMS_SUCCESS,
  payload: { assetShareClassTerms },
});


export const fetchShareclassTermsFailure = (errorMessage) => ({
  type: FETCH_ASSETSHARECLASSTERMS_FAILURE,
  payload: { errorMessage }
});

//GET Asset Exposure Widget
export const getAssetExposures = (AssetId) => {
  return (dispatch) => {
      dispatch(fetchPrivateExposureSummaryBegin());
      sbaAxios({
          url: `${getAssetPrivateExposureSummary}${AssetId}`,
          method: 'get',
      })
          .then((repos) => {
              const assetPrivateExposureSummary = repos;
              //Add logic to format the DataItem if needed using map
              dispatch(fetchPrivateExposureSummarySuccess(assetPrivateExposureSummary));
              return assetPrivateExposureSummary;
          })
          .catch((error) => dispatch(fetchPrivateExposureSummaryFailure(error)));
  };
}
export const fetchPrivateExposureSummaryBegin = () => ({
  type: FETCH_ASSETPRIVATEEXPOSURE_BEGIN,
});

export const fetchPrivateExposureSummarySuccess = (assetPrivateExposureSummary) => ({
  type: FETCH_ASSETPRIVATEEXPOSURE_SUCCESS,
  payload: { assetPrivateExposureSummary },
});


export const fetchPrivateExposureSummaryFailure = (errorMessage) => ({
  type: FETCH_ASSETPRIVATEEXPOSURE_FAILURE,
  payload: { errorMessage }
});